module.exports = __webpack_public_path__ + "frontend/images/white/visual/white-bg@2.jpg?7a26bd690a4c9049f810d55ba720b1ea";